import { Form } from 'common/components';
import { useProductDetail } from 'pages/product-full-view/components/product-new-detail-view/ProductDetailContext';
import { FormItemDecimalNumber } from 'pages/product-full-view/shared/components';

export const FormItemShortBarrelRifleBarrelLength = (props) => {
  const { property } = props;

  const { formInstance } = useProductDetail();

  const shortBarrelRifleValue = Form.useWatch('ShortBarrelRifle', formInstance);

  if (shortBarrelRifleValue === true) {
    return (
      <FormItemDecimalNumber
        property={property}
        labelCol={{ span: 6 }}
        step={0.1}
        precision={1}
      />
    );
  }

  return null;
};

export const FormItemShortBarrelShotgunBarrelLength = (props) => {
  const { property } = props;

  const { formInstance } = useProductDetail();

  const shortBarrelShotgunValue = Form.useWatch(
    'ShortBarrelShotgun',
    formInstance
  );

  if (shortBarrelShotgunValue === true) {
    return (
      <FormItemDecimalNumber
        property={property}
        labelCol={{ span: 6 }}
        step={0.1}
        precision={1}
      />
    );
  }

  return null;
};
